module.exports = __webpack_public_path__ + "static/media/IMG-10.3756c347.jpg";